import { Typography } from "@mui/material";
import { EllipsesStyle } from "../Types/IEllipsesStyle";
import { IKeyDriveFonts } from "../Types/IKeyDriveFonts";

export function KeyDriveh2Header({
    text,
    needEllipses,
    color,
    needBold
}: IKeyDriveFonts) {
    return (
        <Typography
            variant="h2"
            fontFamily="SEGOE UI"
            fontSize="28px"
            lineHeight="36.4px"
            color={color}
            fontWeight={needBold ? 600 : 400}
            sx={needEllipses ? EllipsesStyle : {}}
            textTransform="none"
        >
            { text }
        </Typography>
    )
}